<template>
    <div class="grid-content">
        <div class="grid-item grid-item-full">
            <v-select
                label="Account Type"
                :options="accountTypes"
                :show-labels="false"
                :preselect-first="true"
                :allow-empty="false"
                placeholder="Selected"
                @input="update"
                v-model="form.accountType"/>
        </div>
        <div class="grid-item grid-item-full">
            <r-input @input="update" label="Bank Name" v-model="form.bankName"/>
        </div>
        <div class="grid-item grid-item-full">
            <r-input @input="update" label="Account Number" v-model="form.accountNumber" :validate="validate.accountNumber"/>
        </div>
        <div class="grid-item grid-item-full">
            <r-input @input="update" label="Routing Number" v-model="form.routingNumber" :validate="validate.routingNumber"/>
        </div>
    </div>
</template>

<script>
    import {vSelect} from '@/components/form';

    export default {
        name: 'ach-form',
        components: {vSelect},
        props: {
            validate: {
                type: Object,
            },
        },
        data() {
            return {
                accountTypes: [
                    {label: 'Checking', value: 'checking'},
                    {label: 'Savings', value: 'savings'},
                    {label: 'Other', value: 'other'},
                ],
                form: {
                    accountType: 'checking',
                    bankName: null,
                    accountNumber: null,
                    routingNumber: null,
                    status: 'active',
                    address: {},
                },
            };
        },
        methods: {
            update() {
                this.$emit('input', this.form);
            },
        },
    };
</script>
